import React from 'react';
import { motion } from 'framer-motion';
export function Board() {
  const boardMembers = [{
    name: 'Thomas Schoaf',
    title: 'Board Member',
    image: 'https://litchfieldpark.gov/ImageRepository/Document?documentID=8738',
    bio: 'Longtime West Valley attorney and current Mayor of Litchfield Park with deep roots in business law and community leadership.'
  }, {
    name: 'Jennifer Polansky',
    title: 'Board Member',
    image: 'https://www.JenniferPolansky.com/briefcase/139926_111202572910AM88789.jpg',
    bio: 'West Valley entrepreneur, Rotarian, and community builder who founded the Estrella Community Garden and serves on the Southwest Valley Chamber of Commerce Board of Directors.'
  }, {
    name: 'Joseph Pizzillo',
    title: 'Board Member',
    image: 'https://www.goodyearaz.gov/home/showpublishedimage/728/638721164647930000',
    bio: 'Current Mayor of Goodyear and seasoned finance professional with 30 years of experience in government budgeting and economic development.'
  }, {
    name: 'Brannon Hampton',
    title: 'Board Member',
    image: 'https://www.goodyearaz.gov/home/showpublishedimage/21530/638233913082230000',
    bio: "West Valley financial advisor and current Goodyear City Council Vice Mayor committed to growing the region's business community."
  }, {
    name: 'Jodi Tas',
    title: 'Board Member',
    image: 'https://cdn.magicpatterns.com/uploads/5F1Y1u9TVh8A8FNaE387S6/pasted-image.jpg',
    bio: 'City of Surprise Government Relations Director and trusted connector between West Valley businesses and elected officials.'
  }, {
    name: 'Mike Pineda',
    title: 'Board Member',
    image: 'https://www.avondaleaz.gov/home/showpublishedimage/11563/638744549019100000',
    bio: 'Mayor of Avondale, lifelong West Valley resident, and Business Program Director at Estrella Mountain Community College with a deep background in small business development and entrepreneurship.'
  }];
  return <section id="leadership" className="py-24 bg-pac-sand" data-id="element-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3">
        <div className="text-center mb-16" data-id="element-4">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-pac-navy mb-4" data-id="element-5">
            Board of Directors
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-6">
            Experienced leaders committed to the future of the West Valley.
          </p>
          <div className="w-24 h-1 bg-pac-red mx-auto mt-6" data-id="element-7"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-center" data-id="element-8">
          {boardMembers.map((member, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl overflow-hidden shadow-lg border border-slate-200" data-id="element-9">
              <div className="aspect-[4/5] w-full overflow-hidden bg-slate-100" data-id="element-10">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover object-[center_20%] hover:scale-105 transition-transform duration-500" data-id="element-11" />
              </div>
              <div className="p-6 text-center" data-id="element-12">
                <h3 className="font-serif text-2xl font-bold text-pac-navy mb-1" data-id="element-13">
                  {member.name}
                </h3>
                <p className="text-pac-red font-bold text-sm uppercase tracking-wider mb-4" data-id="element-14">
                  {member.title}
                </p>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-15">
                  {member.bio}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}